/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ServiceType {
    SimAudioServer = 2,
    SimRecordingServer = 4,
    RavenDB = 16,
    AsteriskSocketClient = 64,
    RtspToWebRtcProxy = 512,
    WebAdmin = 1024,
    RtspServer = 2048,
    SimPortal = 4096,
}
